import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, UserCheck, Upload, Trash2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "@/components/PageHeader";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export default function Privacy() {
  const navigate = useNavigate();
  const [confirm, setConfirm] = useState(false);
  const deleteAccount = async () => {
    navigate("/perfil"); toast("Use “Excluir minha conta” no fim do Perfil: confirmação em três etapas com senha.");
  };
  const items = [
    [Lock, "Autenticação segura", "Sua conta é protegida por senha criptografada e sessão autenticada."],
    [UserCheck, "Isolamento por usuário", "Cada pessoa vê somente as próprias memórias. Nunca usamos seus dados para responder a outra pessoa."],
    [Upload, "Uploads protegidos", "Fotos e documentos ficam em armazenamento privado, acessível apenas por você."],
    [Trash2, "Você no controle", "Exclua memórias quando quiser, ou exclua sua conta e todos os dados de uma vez."],
  ];
  return (
    <div className="pb-10">
      <PageHeader title="Privacidade e segurança" />
      <div className="ga-fade-up px-5">
        <div className="rounded-3xl p-6 text-white" style={{ background: "linear-gradient(135deg,#05324A,#0A6373)" }}>
          <ShieldCheck color="#33D9B2" size={28} />
          <h2 className="mt-3 text-2xl font-semibold" data-testid="privacy-headline">Suas memórias são privadas.</h2>
          <p className="mt-1 text-sm text-white/80">Privacidade é prioridade no Clicou, Guardou!.</p>
        </div>
        <div className="mt-4 space-y-2.5">
          {items.map(([I, t, d]) => (
            <div key={t} className="ga-card flex gap-3 p-4"><I size={20} className="mt-0.5 shrink-0" style={{ color: "#0A6373" }} /><div><div className="text-sm font-semibold">{t}</div><p className="ga-muted text-xs">{d}</p></div></div>
          ))}
        </div>
        <button onClick={() => setConfirm(true)} className="ga-card mt-6 w-full p-4 text-sm font-semibold text-red-500" data-testid="privacy-delete-account-button">Excluir minha conta e todos os dados</button>
      </div>
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent className="max-w-sm rounded-3xl">
          <AlertDialogHeader><AlertDialogTitle>Excluir conta?</AlertDialogTitle><AlertDialogDescription>Todas as memórias, anexos e lembretes serão apagados permanentemente.</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel className="rounded-full" data-testid="privacy-delete-cancel">Cancelar</AlertDialogCancel><AlertDialogAction onClick={deleteAccount} className="rounded-full bg-red-500 hover:bg-red-600" data-testid="privacy-delete-confirm">Excluir tudo</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
